import { createSlice, createSelector } from "@reduxjs/toolkit";
import jwt from "jwt-decode";
import { apiCallBegan } from "./api";

const slice = createSlice({
  name: "auth",
  initialState: {
    user: null,
    token: null,
    loading: true,
  },
  reducers: {
    login: (auth, action) => {
      //console.log(action.payload)
      const user = action.payload;
      auth.user = user;
      auth.token = user.verificationToken;
    },
    logout: (auth, action) => {
      auth.user = null;
      auth.token = null;
    },
    refresh: (auth, action) => {
      const user = action.payload;
      auth.user = user;
      auth.token = user.verificationToken;
    },
    setLoginUserType: (auth, action) => {
      auth.user = { ...auth.user, ...action.payload };
    },
  },
});

export const { login, logout, refresh, setLoginUserType } = slice.actions;
export default slice.reducer;

export const sign = (email, password) =>
  apiCallBegan({
    url: "auth/login",
    method: "post",
    data: {
      email: email,
      password: password,
    },
    onSuccess: login.type,
    withCredentials: true,
  });

export const loggedOut = (email, password) =>
  apiCallBegan({
    url: "auth/logout",
    method: "get",
    onSuccess: logout.type,
    withCredentials: true,
  });

export const getRefreshToken = () =>
  apiCallBegan({
    url: "auth/refresh",
    onSuccess: refresh.type,
    withCredentials: true,
    onError: logout.type,
  });

export const getLoggedUser = createSelector(
  (state) => state.auth,
  (auth) => auth.user
);

export const getLoggedUserToken = createSelector(
  (state) => state.auth,
  (auth) => auth.token
);
